import { freeze } from 'icepick';
import type { EstimationConfig } from '../../../../model/types';
import {
	type FetchEstimationConfigSuccess,
	FETCH_ESTIMATION_CONFIG_SUCCESS,
} from '../../../actions/estimation-config';

export type Action = FetchEstimationConfigSuccess;

const defaultState: EstimationConfig = {
	current: {
		customFieldId: null,
		// todo import from i18n messages
		name: 'Issue count',
	},
};

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (state: EstimationConfig = defaultState, action: Action): EstimationConfig => {
	switch (action.type) {
		case FETCH_ESTIMATION_CONFIG_SUCCESS:
			return freeze(action.payload);
		default: {
			const _exhaustiveCheck: never = action.type;
			return state;
		}
	}
};
